import {
  getIdentityVerificationStatus as getStatus,
  getIdentityVerificationWaitOutcome as getWaitOutcome,
  getPaymentCapabilityStatus as getCapability,
  isFailedAchRestrictionRetryTarget as isRetryTarget,
  isIdentityActionRequiredForPayments as isActionRequired,
  isIdentityReviewOrRestrictionBlockingPayments as isReviewOrRestrictionBlocking,
  isPaymentsUnavailableDueToFailedAch as isFailedAch,
  isPaymentsUnavailableDueToIdentityRejection as isRejected,
  requiresIdentityDocumentVerification as requiresDocument,
} from './identityVerificationPolicy.mjs';

export type IdentityVerificationStatus =
  | 'not_started'
  | 'pending'
  | 'verified'
  | 'document_required'
  | 'retryable_rejected'
  | 'permanently_rejected';

export type PaymentCapabilityStatus = IdentityVerificationStatus | 'failed_ach_unresolved';

export const getIdentityVerificationStatus = (userData: any): IdentityVerificationStatus => getStatus(userData) as IdentityVerificationStatus;
export const isPaymentsUnavailableDueToIdentityRejection = (userData: any): boolean => isRejected(userData);
export const isPaymentsUnavailableDueToFailedAch = (userData: any): boolean => isFailedAch(userData);
export const isFailedAchRestrictionRetryTarget = (
  userData: any,
  target?: { sessionId?: string | null; inviteId?: string | null } | null
): boolean => isRetryTarget(userData, target);
export const getPaymentCapabilityStatus = (
  userData: any,
  target?: { sessionId?: string | null; inviteId?: string | null } | null
): PaymentCapabilityStatus => getCapability(userData, target) as PaymentCapabilityStatus;
export const requiresIdentityDocumentVerification = (userData: any): boolean => requiresDocument(userData);
export const isIdentityActionRequiredForPayments = (
  userData: any,
  target?: { sessionId?: string | null; inviteId?: string | null } | null
): boolean => isActionRequired(userData, target);
export const isIdentityReviewOrRestrictionBlockingPayments = (
  userData: any,
  target?: { sessionId?: string | null; inviteId?: string | null } | null
): boolean => isReviewOrRestrictionBlocking(userData, target);
export const getIdentityVerificationWaitOutcome = (
  status: PaymentCapabilityStatus
): 'verified' | 'document_required' | 'permanently_rejected' | 'pending' => getWaitOutcome(status);
